<div class="addContainer">
    <div class="modalHeader" [class]="device.isMobile() ? 'm-b-20' : 'm-b-10'">
      <div class="modal-about" [tabIndex]="1">Accesibilitate</div>
      <button mat-icon-button (click)="dialogRef.close(false)" class="close" aria-label="Inchidere fereastra" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <form class="register-form" #form="ngForm">
    <mat-dialog-content>
        <div class="row">
            <div class="col-12">
                <div class="p-t-10 p-b-10 m-b-10">
                    <mat-slide-toggle color="primary" (change)="onToggleChange($event)">Alb / negru</mat-slide-toggle>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 m-b-20">
                <p class="m-b-5">Dimeniune font</p>
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (valueChange)="onFontSizeChange($event)">
                    <mat-button-toggle [value]="1">Normal</mat-button-toggle>
                    <mat-button-toggle [value]="2">Mediu</mat-button-toggle>
                    <mat-button-toggle [value]="3">Mare</mat-button-toggle>
                  </mat-button-toggle-group>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="w-100 text-center">
        <button mat-raised-button color="primary" type="button" (click)="dialogRef.close(false)">Inchide</button>
      </div>
    </mat-dialog-actions>
  </form>
  </div>